import { ArrowUp, ArrowDown, Pencil, Trash2, Mail, Phone, Globe } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { SponsorLogo } from "@/components/SponsorsCarousel";

const IconBtn = ({ children, ...p }) => (
  <button type="button" className="w-8 h-8 grid place-items-center rounded-md border border-[#E5E7EB] text-gray-600 hover:border-[#E60000] hover:text-[#E60000] disabled:opacity-30 disabled:pointer-events-none transition-colors" {...p}>{children}</button>
);

export const SponsorRow = ({ s, i, total, move, edit, toggle, remove, prefix = "sponsor-row", tag }) => (
  <li className="flex flex-col sm:flex-row sm:items-center gap-4 py-4 border-b border-[#F0F0F0] last:border-0" data-testid={`${prefix}-${s.id}`}>
    <div className="flex items-center gap-3">
      <span className="w-6 text-center font-mono text-xs text-gray-400">{i + 1}</span>
      <div className="h-16 w-32 grid place-items-center bg-[#F8F9FA] border border-[#E5E7EB] rounded-md"><SponsorLogo s={s} className="h-12" /></div>
    </div>
    <div className="flex-1 min-w-0">
      <div className="font-semibold flex items-center gap-2" data-testid={`${prefix}-name-${s.id}`}>{s.name}{tag && <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500 bg-gray-100 rounded px-1.5 py-0.5">{tag}</span>}</div>
      <div className="text-xs text-gray-500 flex flex-wrap gap-x-4 gap-y-1 mt-1">
        {s.phone && <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" />{s.phone}</span>}
        {s.email && <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" />{s.email}</span>}
        {s.website && <span className="inline-flex items-center gap-1 break-all"><Globe className="w-3 h-3" />{s.website}</span>}
      </div>
    </div>
    <div className="flex items-center gap-2">
      <label className="flex items-center gap-2 text-xs text-gray-600 mr-2"><Switch checked={s.active} onCheckedChange={() => toggle(s)} data-testid={`${prefix}-active-${s.id}`} />{s.active ? "Shown" : "Hidden"}</label>
      <IconBtn onClick={() => move(i, -1)} disabled={i === 0} aria-label="Move up" data-testid={`${prefix}-up-${s.id}`}><ArrowUp className="w-4 h-4" /></IconBtn>
      <IconBtn onClick={() => move(i, 1)} disabled={i === total - 1} aria-label="Move down" data-testid={`${prefix}-down-${s.id}`}><ArrowDown className="w-4 h-4" /></IconBtn>
      <IconBtn onClick={() => edit(s)} aria-label="Edit" data-testid={`${prefix}-edit-${s.id}`}><Pencil className="w-4 h-4" /></IconBtn>
      <IconBtn onClick={() => remove(s)} aria-label="Delete" data-testid={`${prefix}-delete-${s.id}`}><Trash2 className="w-4 h-4" /></IconBtn>
    </div>
  </li>
);

export const swap = (list, i, d) => {
  const next = [...list];
  [next[i], next[i + d]] = [next[i + d], next[i]];
  return next;
};
